import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import api from "@/lib/api";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Home from "@/pages/Home";

function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const [view, setView] = useState("home"); // home | login

  useEffect(() => {
    const token = localStorage.getItem("srb_token");
    if (!token) {
      setChecking(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("srb_token"))
      .finally(() => setChecking(false));
  }, []);

  const onLogin = (token, u) => {
    localStorage.setItem("srb_token", token);
    setUser(u);
  };
  const onSignOut = () => {
    localStorage.removeItem("srb_token");
    setUser(null);
    setView("home");
  };

  let body;
  if (checking) body = null;
  else if (user) body = <Dashboard user={user} onSignOut={onSignOut} />;
  else if (view === "login") body = <Login onLogin={onLogin} onBack={() => setView("home")} />;
  else body = <Home onSignIn={() => setView("login")} />;

  return (
    <div className="srb">
      <Toaster theme="dark" position="top-center" richColors />
      {body}
    </div>
  );
}

export default App;
